/**
 * The Cispracs ID profile language (amendment 12).
 *
 * Bunker keeps its own choice (`bunker.lang`), so the platform must not
 * override it on every load. The platform language is applied only when it
 * differs from the one we last applied: a change on cispracs.ru reaches Bunker,
 * while a switch made here stays until the platform value changes again.
 * Anything but "ru"/"en" (incl. null/absent) is no information.
 */
export const PLATFORM_LANG_KEY = 'bunker.platformLang';

interface Target {
  resolvedLanguage?: string;
  changeLanguage: (lng: string) => unknown;
}

function read(storage: Storage): string | null {
  try {
    return storage.getItem(PLATFORM_LANG_KEY);
  } catch {
    // Storage blocked (private mode, policy): treat as never applied.
    return null;
  }
}

function write(storage: Storage, value: string): void {
  try {
    storage.setItem(PLATFORM_LANG_KEY, value);
  } catch {
    // Without the marker the platform language is simply re-applied next load.
  }
}

export function applyPlatformLocale(locale: string | null | undefined, target: Target, storage: Storage): void {
  if (locale !== 'ru' && locale !== 'en') return;
  if (read(storage) === locale) return;
  write(storage, locale);
  if (target.resolvedLanguage !== locale) void target.changeLanguage(locale);
}
